import * as React from 'react';
import { JRCIcon } from '../../JRCIcon/JRCIcon';
import { JRCTooltip, JRCTooltipProps } from '../../JRCTooltip/JRCTooltip';
import styled from 'styled-components';
import { Colors } from 'styles/theme';

/**
 * interface HelperProps props of the Form Helper Icon
 * @member tooltip, content of the tooltip (required)
 * @member color, icon helper color (should be grey3 when unfocused, yellow when focused)
 */
export type HelperProps = {
    tooltip: Omit<JRCTooltipProps, 'children'>;
    color: Colors;
    size?: number;
};

const JRCHelperStyled = styled.span`
    cursor: pointer;
    margin-left: 5px;
`;
const FormHelper = (props: HelperProps) => (
    <JRCHelperStyled>
        <JRCTooltip {...props.tooltip}>
            <JRCIcon name="icon-question-circle-o" size={props.size} color={props.color} />
        </JRCTooltip>
    </JRCHelperStyled>
);

export default FormHelper;
